<template lang='pug'>
  carousel.carousels.services.component(
    :perPageCustom="[[180, 1], [360, 2], [540, 3], [720, 4], [900, 5]]"
    :key='coupons.length'
  )
    slide.slide( v-if='merchant.rewards && merchant.rewards.rsv && merchant.rewards.rsv.active' )
      .reward.container
        .bg
          h3 {{ $t('Coupon') }}
          h3 {{ $t('Coupon') }}
          h3 {{ $t('Coupon') }}
        .overlay
          h5 {{ $t('Use BlueFaucet to Make Reservation') }}
          h4 {{ merchant.rewards.rsv.discount }}
    slide.slide( v-if='merchant.rewards && merchant.rewards.ref && merchant.rewards.ref.active' )
      .reward.container
        .bg
          h3 {{ $t('Coupon') }}
          h3 {{ $t('Coupon') }}
          h3 {{ $t('Coupon') }}
        .overlay
          h5 {{ $t('Refer a Friend') }}
          h4 {{ merchant.rewards.ref.discount }} 
    slide.slide( v-if='merchant.rewards && merchant.rewards.first && !visited && merchant.rewards.first.active' )
      .reward.container
        .bg
          h3 {{ $t('Coupon') }}
          h3 {{ $t('Coupon') }}
          h3 {{ $t('Coupon') }}
        .overlay
          h6 {{ $t('First Time Visit') }}
          h4 {{ merchant.rewards.first.discount }}

    slide.slide( v-for='item, i in coupons' :key='item.id' )
      coupon-card( :item='item' @click.native='$emit( "show", item )' )
</template>

<script>
  import { db } from '@/main'
  import { Carousel, Slide } from 'vue-carousel'
  import CouponCard from '@/components/cards/coupon'

  export default {
    name: 'carousels.coupons.component',

    components: {
      Carousel,
      Slide,
      CouponCard
    },

    props: {
      visited: Boolean,
      user: Object,
      account: [ Object, Array ],
      merchant: { default: false },
      coupons: { default: () => ([]) }
    }
  }
</script>

<style scoped lang='stylus'>
  .slide
    .cards.service
      margin-left 16px
    &:first-child .reward
      margin-left 0
  
  .reward
    background white
    height 100%
    box-sizing border-box
    padding 0 8px
    border 1px solid rgb(140 140 140)
    border-radius 5px
    margin-left 16px
    
    .bg
      position absolute
      font-size 1.35em
      height 100%
      width 100%
      text-align center
      color rgb( 200 200 200 )
      left 0
      top 0
      h1
        letter-spacing 4px
    .overlay
      text-align center
      position relative
      height 100%
      box-sizing border-box
      padding 16px
      background rgba( 255 255 255 1 )
      display flex
      flex-direction column
      h5
        min-height 36px
      h4
        padding 24px 16px
        background rgba( 75 220 255 .25 )
        border-radius 10px
        border 1px solid rgb(200 200 200)
        color rgb( 240 50 50 )
        margin-top 10px
        flex-grow 1
</style>
